import React from 'react';
import ReactDOMServer from 'react-dom/server';
import HeaderBackground from 'components/Learn/Header/HeaderBackground';
import Welcome from 'components/Learn/Header/Welcome';
import { useDimensions } from 'components/shared/hooks';
import SearchBox from 'components/shared/SearchBox';
import { HeaderStyle } from './types';

const HeaderImage = ({ headerDesign }) => {
  const [ref, dimensions] = useDimensions();

  const getBackground = (headerStyle, parentDimensions) => {
    if (!headerStyle || headerStyle === 'default') {
      return { background: 'rgba(222, 221, 221, 0.34)' };
    }
    const svgString = encodeURIComponent(
      ReactDOMServer.renderToStaticMarkup(
        <HeaderBackground
          type={headerStyle}
          parentDimensions={parentDimensions}
        />,
      ),
    );
    return {
      background: `url('data:image/svg+xml;utf8, ${svgString}') white no-repeat`,
    };
  };

  return (
    <div
      className="WelcomeLearnHeader-wrapper w-fill minh-150 border bdrs-4 mt-4 mb-4"
      style={getBackground(headerDesign, dimensions)}
      ref={ref}
    >
      <div className="ml-16">
        <Welcome />
      </div>
      <div className="WelcomeLearnHeader-search mw-300">
        <SearchBox useFeatherIcon />
      </div>
    </div>
  );
};

HeaderImage.propTypes = {
  headerDesign: HeaderStyle,
};

export default HeaderImage;
